
export interface ThemeClasses {
  cardClass: string;
  titleClass: string;
  buttonClass: string;
  resetClass: string;
  addClass: string;
  resultClass: string;
}

export const getThemeClasses = (theme: string): ThemeClasses => {
  switch (theme) {
    case "elf-letter-bot":
      return {
        cardClass: "border-elfGreen bg-elfGreen-lighter shadow-md",
        titleClass: "text-elfGreen-dark",
        buttonClass: "bg-elfRed hover:bg-elfRed-dark text-white",
        resetClass: "bg-elfGreen hover:bg-elfGreen-dark text-white",
        addClass: "bg-elfGreen hover:bg-elfGreen-dark text-white",
        resultClass: "bg-elfYellow-light p-4 rounded-lg my-4",
      };
    case "christmas":
      return {
        cardClass: "border-red-600 bg-green-50 shadow-md",
        titleClass: "text-red-600",
        buttonClass: "bg-red-600 hover:bg-red-700 text-white",
        resetClass: "bg-green-600 hover:bg-green-700 text-white",
        addClass: "bg-green-600 hover:bg-green-700 text-white", 
        resultClass: "bg-red-50 p-4 rounded-lg border border-red-200 my-4",
      };
    default:
      return {
        cardClass: "border-primary bg-card shadow-md",
        titleClass: "text-primary",
        buttonClass: "bg-primary hover:bg-primary/90 text-primary-foreground",
        resetClass: "bg-secondary hover:bg-secondary/90 text-secondary-foreground",
        addClass: "bg-primary hover:bg-primary/90 text-primary-foreground",
        resultClass: "bg-muted p-4 rounded-lg my-4",
      };
  }
};
